import { useEffect, useState } from 'react';
import UsageServices from '../services/usageServices';
// import { notification } from '@src/utils/Notification';

function useUsage() {
  const [usages, setUsages] = useState([]);

  const findAllUsages = () => {
    UsageServices.getAll()
      .then((res) => setUsages(res.data?.data))
      .catch((error) => console.log(error));
  };

  // useEffect(() => {
  //   findAllUsages();
  // }, []);

  const createUsage = (data, callback = () => { }) => {
    UsageServices.create(data)
      .then(() => {
        findAllUsages();
        // notification('Usage enregistré avec succès!');
        callback();
      })
      .catch((error) => console.log(error));
  };

  const updateUsageComputer = (id, data) => {
    return UsageServices.updateUsageComputer(id, data)
  }

  return { usages, createUsage, updateUsageComputer };
}

export default useUsage;